import { render, staticRenderFns } from "./TransactionFunctionCall.vue?vue&type=template&id=741a9854&scoped=true&"
import script from "./TransactionFunctionCall.vue?vue&type=script&lang=js&"
export * from "./TransactionFunctionCall.vue?vue&type=script&lang=js&"
import style0 from "./TransactionFunctionCall.vue?vue&type=style&index=0&id=741a9854&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741a9854",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
